import { render, staticRenderFns } from "./NewDatasetView.vue?vue&type=template&id=316ea004&scoped=true"
import script from "./NewDatasetView.vue?vue&type=script&lang=js"
export * from "./NewDatasetView.vue?vue&type=script&lang=js"
import style0 from "./NewDatasetView.vue?vue&type=style&index=0&id=316ea004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ea004",
  null
  
)

export default component.exports